import styled from 'styled-components/macro';
import { getFlex } from '../styleUtils';

interface DividerWrapperProps {
  space: number;
}
export const DividerWrapper = styled.div<DividerWrapperProps>`
  ${getFlex()}
  margin: ${({ space }) => `${space * 4}px 0`};
  span:not(.text) {
    display: block;
    height: 1px;
    /* background-color: var(--blueGray-200); */
    background-color: #e8f2fe;
    flex: 1;
  }
  .text {
    padding: 0 0.5rem;
    color: var(--blueGray-500);
  }
`;
